import { LeadList } from "./LeadList";
import { LeadShow } from "./LeadShow";

export default {
  list: LeadList,
  show: LeadShow,
};
